import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const Setoressetores = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>

                    <HeaderVerde texto="SETORES DO SERVIÇO" />
                    <div style={{textAlign:"left"}}>
                        <Input label="Recepção" nome="recpcao" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Escritório/Administração" nome="adm" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Copa" nome="copa" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Banheiro" nome="banheiro" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Lavanderia" nome="lavanderia" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Depósito" nome="deposito" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Outros" nome="outrosServico" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="83vw" widthMobile="80vw" marginR="3vw" />
                    </div>

                    <HeaderVerde texto="SETORES DA ASSISTÊNCIA" />
                    <div style={{textAlign:"left"}}>
                    <Input label="Sala de Avaliação" nome="avaliacao" modulo={modulo} index={n}
                        componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                    <Input label="Sala de Pilates" nome="pilates" modulo={modulo} index={n}
                        componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                    <Input label="Ginásio de Atendimento" nome="ginasio" modulo={modulo} index={n}
                        componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                    <Input label="Sala de Terapia Manual" nome="terapiamanual" modulo={modulo} index={n}
                        componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                    <Input label="Piscina Terapêutica" nome="piscina" modulo={modulo} index={n}
                        componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                    <Input label="Outros" nome="outrosAssistencia" modulo={modulo} index={n}
                        componentDisplay="inline-grid" widthWeb="83vw" widthMobile="80vw" marginR="3vw" />
                    </div>

                    <HeaderVerde texto="SALAS ESPECÍFICAS DE ATENDIMENTO" />

                    <CheckContainer>
                        <CheckBox texto="Ortopedia/Traumatologia/Reumatologia" grupo="setores" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Neurologia" grupo="setores" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Pediatria" grupo="setores" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Respiratória" grupo="setores" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Postura e Terapias Manuais" grupo="setores" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Ginásio Terapêutico" grupo="setores" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Aquática" grupo="setores" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Dermatofuncional" grupo="setores" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Outros" grupo="setores" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                    </CheckContainer>

                </Caixa>
            )
        }
        return partes
    }
}

export default Setoressetores